import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {userLoggedOut, logout} from 'actions/connect';
import {Link} from 'react-router';

class UserMenu extends React.Component {
    constructor(props) {
        super(props);
        this.displayName = 'UserMenu';
        this.handleLockScreen = this.handleLockScreen.bind(this);
    }
    handleLockScreen(event) {
    	event.preventDefault();
    	this.props.dispatch(userLoggedOut());
    }
    render() {
    	var user = this.props.user;
      if(!user || !user._id || !user.name) {
        return null
      }
		return (
			<div id="userbox" className="userbox">
				<a href="#" data-toggle="dropdown">
					<figure className="profile-picture">
						<img src="assets/images/!logged-user.jpg" alt="Joseph Doe" className="img-circle" data-lock-picture="assets/images/!logged-user.jpg" />
					</figure>
					<div className="profile-info">
						<span className="name">{user.name.first + ' ' + user.name.last}</span>
						<span className="role">{user.role}</span>
					</div>

					<i className="fa custom-caret"></i>
				</a>

				<div className="dropdown-menu">
					<ul className="list-unstyled">
						<li className="divider"></li>
						<li>
							<Link to={"/account/billing"}><i className="fa fa-user"></i> My Account</Link>
						</li>
						{/*
						<li>
							<a role="menuitem" onClick={this.handleLockScreen} tabIndex="-1" href="#" data-lock-screen="true"><i className="fa fa-lock"></i> Lock Screen</a>
						</li>*/}
						<li>
							<div
								role="menuitem"
								tabIndex="-1"
								className='power-off-button'
								onClick={() => this.props.dispatch(logout())}>
									<i className="fa fa-power-off power-off-button-text"></i>
									{' '}Logout
							</div>
						</li>
					</ul>
				</div>
			</div>
		)
	}
}

var mapStateToProps = function(state) {
	return {
		user : state.connection.user
	}
}

export default connect(mapStateToProps)(UserMenu);



// WEBPACK FOOTER //
// ./src/browser/components/header/userMenu.js